module.exports = __webpack_public_path__ + "static/media/hc-mishra.71047c40.png";